module.exports = __webpack_public_path__ + "static/media/bulk_validate_remarks.0027c436.csv";